import AppBadge from 'shared/badges/app-badge'

// Maps a user's resolved Auth0 status to a badge. `deleted` means the user has
// no Auth0 account (never provisioned, or removed in Auth0).
const STATES = {
  active: { variant: 'success', label: 'Active' },
  blocked: { variant: 'danger', label: 'Blocked' },
  deleted: { variant: 'secondary', label: 'No Auth0 Account' }
}

const UserStatusBadge = ({ state, className = '' }) => {
  const { variant, label } = STATES[state] || STATES.active

  return (
    <AppBadge variant={variant} className={className}>
      {label}
    </AppBadge>
  )
}

export default UserStatusBadge
